<template>
  <div>
    <div
      style="height:calc(100vh - 400px); background:rgba(255,255,255,0.5) padding:20px; backdrop-filter: blur(10px);
    background: rgba(255,255,255,0.8);"
    >
      <BarChart
        :chart-data="datacollection"
        :options="chartOptions"
        class="yearly-chart"
      ></BarChart>
    </div>
    <div id="chart-progress">
      <div style="font-size:small; margin-bottom:5px;">
        Total Terbayar:
        <span style="float:right;" class="data-total">
          [{{ ((form.SudahBayar / form.Total) * 100).toFixed(2) }}%]
          {{ (form.Terbayar + form.TerbayarTelat) | format }}
        </span>
      </div>
      <div style="margin-top:7px;">
        <v-icon color="#4DB6AC">mdi-circle-medium</v-icon>
        Terbayarkan Tepat Waktu
        <span style="float:right;" class="data-terbayar">
          {{ form.Terbayar | format }}
        </span>
      </div>
      <div style="margin-top:7px;">
        <v-icon color="green">mdi-circle-medium</v-icon>
        Terbayarkan Lewat Jatuh Tempo
        <span style="float:right;" class="data-terbayartelat">
          {{ form.TerbayarTelat | format }}
        </span>
      </div>
      <div style="margin-top:7px;">
        Total Belum Tebayarkan:
        <span style="float:right;" class="data-totalbelum">
          [{{ ((form.BelumBayar / form.Total) * 100).toFixed(2) }}%]
          {{ form.BelumBayar | format }}
        </span>
      </div>
      <div style="margin-top:7px;">
        <v-icon color="#4FC3F7">mdi-circle-medium</v-icon>
        Belum Jatuh Tempo
        <span style="float:right;" class="data-belum">
          {{ form.TepatWaktu | format }}
        </span>
      </div>
      <div style="margin-top:7px;">
        <v-icon color="#FFD54F">mdi-circle-medium</v-icon>
        Hampir Jatuh Tempo
        <span style="float:right;" class="data-hampir">
          {{ form.HampirLewat | format }}
        </span>
      </div>
      <div style="margin-top:7px;">
        <v-icon color="#FF8A65">mdi-circle-medium</v-icon>
        Sudah Jatuh Tempo
        <span style="float:right;" class="data-lewat">
          {{ form.SudahLewat | format }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import BarChart from '../../components/Charts/Bar'

export default {
  components: {
    BarChart,
  },
  data: () => ({
    form: {
      Terbayar: 0,
      TerbayarTelat: 0,
      TepatWaktu: 0,
      HampirLewat: 0,
      SudahLewat: 0,
    },
    progress: {},
    datacollection: {},
    chartOptions: {
      title: {
        display: false,
        text: 'Chart',
      },
      legend: {
        labels: {
          usePointStyle: true,
          pointRadius: 2,
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    },
  }),
  props: {
    tipeData: [Number, String],
  },
  watch: {
    tipeData() {
      this.populateProgress()
      this.populateChart()
    },
  },
  created() {
    this.populateProgress()
    this.populateChart()
  },
  methods: {
    async populateProgress() {
      let { data } = await this.$api.call('DOC.ChartYearFlow', {
        Tahun: localStorage.getItem('tahun'),
      })
      this.populateChart(data)
      data.forEach(d => {
        this.form.Terbayar += d.Terbayar ? parseInt(d.Terbayar) : 0
        this.form.TerbayarTelat += d.TerbayarTelat
          ? parseInt(d.TerbayarTelat)
          : 0
        this.form.TepatWaktu += d.TepatWaktu ? parseInt(d.TepatWaktu) : 0
        this.form.HampirLewat += d.HampirLewat ? parseInt(d.HampirLewat) : 0
        this.form.SudahLewat += d.SudahLewat ? parseInt(d.SudahLewat) : 0
      })
      this.form.SudahBayar = this.form.Terbayar + this.form.TerbayarTelat
      this.form.BelumBayar =
        this.form.TepatWaktu + this.form.HampirLewat + this.form.SudahLewat
      this.form.Total = this.form.SudahBayar + this.form.BelumBayar
    },
    async populateChart(data) {
      // let { data } = await this.$api.call('PRM.SelChartYearly', {
      //   TipeData: this.tipeData,
      // })
      let labels = []
      let colors = {
        Terbayar: '#4DB6AC',
        TerbayarTelat: 'green',
        TepatWaktu: '#4FC3F7',
        HampirLewat: '#FFD54F',
        SudahLewat: '#FF8A65',
      }
      let ds = []
      data.forEach(d => {
        labels.push(d.BulanSmall)
        let i = 0
        Object.keys(d).forEach(k => {
          if (colors[k]) {
            ds[i] = ds[i] || {
              data: [],
              baseColor: colors[k],
              pointStyle: 'rectRot',
              pointRadius: 3,
            }
            ds[i].label = k.replace('_', ' ')
            ds[i].stack = k.match(/ALL$/) ? 2 : 1
            ds[i].data.push(d[k])
            i++
          }
        })
      })
      this.datacollection = {
        labels: labels,
        datasets: ds,
      }
    },
    randomScalingFactor() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
  },
}
</script>
<style lang="scss">
.yearly-chart {
  height: calc(100vh - 400px);
  padding: 10px;
  canvas {
    height: 300px;
  }
}
#chart-progress {
  width: 100%;
  height: 240px;
  background: white;
  box-sizing: border-box;
  padding: 15px;
  box-sizing: border-box;
  overflow-y: auto;
  font-size: 14px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
</style>
